import { OrderResponse, OverduePaymentResponse, isOverduePaymentResponse } from '@afterpaytouch/portal-api'

export const getAllScheduleIds = (selectedOrder?: OrderResponse | OverduePaymentResponse): number[] => {
  if (isOverduePaymentResponse(selectedOrder)) {
    return selectedOrder?.overduePaymentSchedules.map((schedule) => schedule.id) ?? []
  }

  const { paymentScheduleSet = [] } = selectedOrder ?? {}
  return paymentScheduleSet.filter((schedule) => schedule.inOwingStatus).map((schedule) => schedule.id)
}
